import React from 'react';
import { useParams } from 'react-router-dom';
import { useQuery, getOrganizationBySlug, getRequestOffers } from 'wasp/client/operations';
import { DashboardLayout } from '../../../client/components/Sidebar';
import { DirectoryEntriesTable } from '../../../components/ui/directory-entries-table';
import { HandHeart } from 'lucide-react';

export default function OrgRequestOfferPage() {
  const { slug } = useParams<{ slug: string }>();
  const { data: org, isLoading: orgLoading } = useQuery(getOrganizationBySlug, { slug: slug! }) as { data: any; isLoading: boolean };

  const { data: items = [], isLoading: itemsLoading } = useQuery(
    getRequestOffers,
    { organizationId: org?.id },
    { enabled: !!org?.id }
  ) as { data: any[]; isLoading: boolean };

  const entries = items.map((item: any) => ({
    id: item.id,
    title: item.title,
    description: item.description,
    category: item.metadata?.category ?? null,
  }));

  return (
    <DashboardLayout>
      <div className="flex items-center justify-between px-6 py-4 border-b border-border">
        <h1 className="text-2xl font-bold text-gray-900">Request &amp; Offer</h1>
      </div>

      {(orgLoading || itemsLoading) && (
        <div className="flex items-center justify-center py-12">
          <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600" />
        </div>
      )}

      {!orgLoading && !itemsLoading && items.length === 0 && (
        <div className="text-center py-12 text-gray-500">
          <HandHeart className="w-12 h-12 mx-auto mb-3 opacity-30" />
          <p>No requests or offers for this organization yet.</p>
        </div>
      )}

      {!orgLoading && !itemsLoading && items.length > 0 && (
        <DirectoryEntriesTable entries={entries} />
      )}
    </DashboardLayout>
  );
}
